import type { IResponse } from '../interface/common';
import { fetch } from '../request';

export interface Body {
  skasset: string;
}

export interface ClotheClothInfo {
  colors: string;
  is_general: string;
  secondary_colors?: string;
  terminal_application: string;
  component_type_en_name: string;
}
export interface Param {
  name: string;
  value: number[] | number;
}
export interface Matconfig {
  name: string;
  params: Param[];
}

export interface Clothe {
  skasset: string;
  matconfig?: Matconfig[];
  cloth_info: ClotheClothInfo;
  sourcebody: string;
}

export interface EyeXgen {
  matdir: string;
  hairasset: string;
  sourcebody: string;
}

export interface HairXgen {
  hairasset: string;
  sourcebody: string;
}

export interface ShoeClothInfo {
  colors: string;
  is_general: string;
  terminal_application: string;
}

export interface Shoe {
  skasset: string;
  cloth_info: ShoeClothInfo;
}

export interface Look {
  Body: Body[];
  Shoes: Shoe[];
  Clothes: Clothe[];
  Hair_Xgen: HairXgen[];
  Eyebrow_Xgen: EyeXgen[];
  Eyelash_Xgen: EyeXgen[];
}

export interface Config {
  character_name: string;
  look: Look;
  look_name: string;
  only_show_character_name: string;
  version: string;
  gender: string;
}

export interface PreviewLayersJSON {
  sit0: string;
  sit1: string;
  sit2: string;
  sit3: string;
  stand1: string;
}

export enum MaterialType {
  Map = 2, // 演播室
  Character = 1, // 人物
  TtsVcn = 3, // 音色
  Subtitle = 4, // 字幕模板
  StaticTextTemplate = 8, // 静态文字模板
  DynamicTextTemplate = 12, // 动态文字模板
  Font = 6, // 字体
  Music = 7, // 音乐
  Audio = 11, // 音效
  Paster = 9, // 贴纸
  AePagTemplateHead = 5, // 片头
  AePagTemplateTail = 13, // 片尾
  Template = 10, // 模板
  CollectionLogo = 15, // 套装logo图
  Collection = 16, // 套装
  HairCollection = 17, // 头发
  MakeupCollection = 18, // 妆容
  Accessory = 19, // 饰品
  Meme = 20, // 表情包
  ThemeLayer = 21, // 主题素材
  Sku = 22, // sku
}

export enum EditIndexType {
  Change = 0, // 换一换
  HotCommend = 1, // 热门推荐
  Banner = 2, // banner位
}

// /material/editor_select_youyan_config/random_names
export const getRandomNames = (params: {
  group_id: MaterialType;
  size: number;
  edit_index_type: EditIndexType;
}) => {
  return fetch<IResponse<string[]>>('/material/editor_select_youyan_config/random_names', {
    method: 'GET',
    params,
  });
};
